import LoadingCar from "../loadingCar";

const Success = ({msg, icon, loadingCar}) => {

    return (
        <div className="d-flex flex-column align-items-center justify-content-center">
            {!icon && !loadingCar && <i className="far fa-check-circle text-success" style={{fontSize:58}}></i>}
            {icon && !loadingCar && <i className={icon+" text-success"} style={{fontSize:58}}></i>}
            {loadingCar && (<LoadingCar/>)}
            <span className="mt-2" style={{fontSize:20}}>
            {msg}
            </span>
        </div>
    );
}

export default Success;

